export default "__VITE_ASSET__BMjciAAm__"